import React from 'react';
import { BoolToString } from 'components';
import { getTableColumns } from 'helpers';

const FundingColumns = [
  ['treatmentAssignment', 'string', 'Tx Arm', 'left', true],
  ['event', 'string', 'Step', 'left', true],
  ['fundingType', 'string', 'Funding Type', 'left', true]
];

const FundingInfoColumns = [
  ...getTableColumns(FundingColumns),
  {
    name: 'isCollectInOpen',
    type: 'string',
    label: 'Collect in OPEN?',
    filterable: true,
    align: 'center',
    renderCell: (data, rowEvents) => <BoolToString boolValue={data.isCollectInOpen} />
  }
];

export default FundingInfoColumns;
